module.exports = __webpack_public_path__ + "img/f-5-2.3bff10ee.png";